import { Heading, SvgIcon, Text } from '@cinch-labs/design-system'
import Image from 'next/legacy/image'

import type { Partner as PartnerCardProps } from '../../../partnerships/types/partnerships-page'
import styles from './partner-card.module.css'

const PartnerCard: React.FC<PartnerCardProps> = ({
  body,
  heading,
  logo,
  url,
}) => {
  const [link] = url || []
  return (
    <li className={styles.container}>
      <div className={styles.logoWrapper}>
        <Image
          src={logo.filename}
          alt={logo.alt ?? undefined}
          layout="fill"
          objectFit="contain"
        />
      </div>
      <div className={styles.inner}>
        <Heading element="h3" className={styles.heading}>
          {heading}
        </Heading>
        <Text className={styles.text}>{body}</Text>
        {link.url ? (
          <a
            href={link.url.cached_url}
            className={styles.link}
            target="_blank"
            rel="noreferrer"
            aria-label={
              heading === 'TRNSMT' ? 'Visit Transmit official site' : ''
            }
          >
            {link.text}
            <SvgIcon name="arrow-right" className={styles.externalLinkIcon} />
          </a>
        ) : null}
      </div>
    </li>
  )
}

export default PartnerCard
